import { useHistory } from "react-router";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {addModifierCategory, addModifierNewCategory, loadModifiers} from "../../../store/Modifiers/api";
import {useDispatch} from "react-redux";
import {onModifiersLoad} from "../../../store/Modifiers/actions";

export const useCreateModifierCategory = () => {
    const dispatch = useDispatch();

    return useMutation(
        ["createModifierCategory"],
        ({ name, chain_id }) => addModifierCategory(name, chain_id),
        {
            onSuccess: async () => {
                dispatch(onModifiersLoad())
            },
        }
    );
};
